import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { useAcademicsService } from '../../../../apis/academics/useAcademicsService';
import { IAcademicsAssessmentCourseMapResponse } from '../../../../apis/academics/academicsAssessments.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getAcademicsAssessmentsForCoursesKey =
  'get-academics-assessments-for-courses';

export const useAcademicsAssessmentsCourseHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<IAcademicsAssessmentCourseMapResponse, TQueryError>
): UseQueryResult<IAcademicsAssessmentCourseMapResponse, TQueryError> => {
  const { getAcademicsAssessmentsForCourses } = useAcademicsService();

  return useQuery<IAcademicsAssessmentCourseMapResponse, TQueryError>({
    queryKey: [getAcademicsAssessmentsForCoursesKey],
    queryFn: () => getAcademicsAssessmentsForCourses(),
    enabled: true,
    ...options,
  });
};
